<template>
  <div class="pt-5">
    <v-btn color="indigo" dark @click="createBlockDialog">
      {{ $t('PLANNINGS.TASKS.BLOCK.TIME') }}
    </v-btn>
    <block-types-dialog v-model="blockDialog" @createBlock="createBlock" />
  </div>
</template>

<script>
import BlockTypesDialog from '@/modules/booking_schedule/components/forms/BlockTypesDialog.vue';

export default {
  name: 'Blockers',
  components: { BlockTypesDialog },

  data() {
    return {
      blockDialog: {}
    };
  },

  methods: {
    createBlockDialog() {
      this.blockDialog = {
        dialog: true,
        options: { agreeBtnText: this.$t('BUTTON.CREATE') }
      };
    },

    createBlock(type) {
      this.$emit('createBlock', type);
    }
  }
};
</script>

<style scoped></style>
